import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';

import { User, UserService } from '@fry/lib/users';
import { FormData } from '@fry/lib/forms';

import { UserEditDetailsForm } from './user-edit-details.form';
import { NotifyService } from '@fry/lib/utils';
import { CanComponentDeactivate } from '@fry/components/common/form';
import { Observable } from 'rxjs';
import { FileUploadControlComponentDelegate } from '@fry/components/common/file-upload-control';
import { UserFileUploadDelegate } from './user-file-upload.service';

@Component({
    selector: 'app-user-edit-details',
    templateUrl: './user-edit-details.component.html',
    providers: [
        UserEditDetailsForm,
        { provide: FileUploadControlComponentDelegate, useClass: UserFileUploadDelegate },
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class UserEditDetailsComponent implements OnInit, CanComponentDeactivate {

  public user: User;
  public formData$: Observable<FormData>;

  constructor(
    private userService: UserService,
    private detailsForm: UserEditDetailsForm,
    private notify: NotifyService,
    private fileUploadDelegate: FileUploadControlComponentDelegate,
  ) { }

  ngOnInit() {
    this.user = this.userService.user;
    this.formData$ = this.detailsForm.init(this.user);
    this.fileUploadDelegate.setContext({ oid: this.user.id });
  }

  onSubmit() {
    this.detailsForm.submit(this.user).subscribe(
      (user) => {
        this.userService.setUser(user);
        this.user = this.userService.user;
        this.notify.success($localize `Profile successfully saved`);
      },
      error => {
        this.notify.error(error);
      }
    );
  }

  canSafelyDeactivate() {
    return this.detailsForm.pristine;
  }
}
